var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "float-window"
  }, [_c("div", {
    staticClass: "float-content"
  }, [_c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "search-result"
  }, [_vm._l(_vm.searchResults, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "result-item",
      on: {
        click: function click($event) {
          return _vm.selectAnswer(item);
        }
      }
    }, [_c("div", {
      staticClass: "result-title",
      domProps: {
        innerHTML: _vm._s(item.question)
      }
    }), _c("div", {
      staticClass: "result-content wlc-double-line",
      domProps: {
        innerHTML: _vm._s(item.content)
      }
    })]);
  }), _vm.searchResults.length ? _c("div", {
    staticClass: "no-more"
  }, [_vm._v(" 没有更多了 ")]) : _c("el-empty", {
    attrs: {
      "image-size": 70,
      description: "暂无数据"
    }
  })], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };